import React from "react";
import "./textInput.css";
import PropTypes from "prop-types";
const InputText = ({
  placeholder,
  value,
  type,
  onChange,
  maxLength,
  onKeyDown,
  onInput,
}) => {
  return (
    <div>
      <input
        className="new-input"
        placeholder={placeholder}
        value={value}
        type={type}
        onChange={onChange}
        maxLength={maxLength}
        onKeyDown={onKeyDown}
        onInput={onInput}
      ></input>
    </div>
  );
};
InputText.protypes = {
  value: PropTypes.string,
  text: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
};
export default InputText;
